import * as React from 'react';
import RunsheetInvoiceItemsData from './RunSheetInvoiceItems';
import type { RunsheetDriverJob } from './models/JobScheduleInterfaces';
import type { ExtraInvoiceItems, ItemTypeList } from './models/InvoiceInterfaces';
import { Link } from 'react-router-dom';

interface RunSheetDriverCalloutProps {
    invoiceItemTypes: ItemTypeList[];
    gst: number;
    job: RunsheetDriverJob;
    updateJobField(fieldName: string, fieldValue: string): void;
    updateJobInvoices(updatedInvoices: ExtraInvoiceItems[]): void;
    save(): void;
}

const RunSheetDriverCallout = (props: RunSheetDriverCalloutProps) => {
    const [chargeCalloutFee, setChargeCalloutFee] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    const deleteError = (errorName: string) => {
        var errorList = errors;
        delete errorList[errorName];
        setErrors(errorList);
    }

    const handleChange = (e: any) => {
        deleteError(e.target.name);

        props.updateJobField(e.target.name, e.target.value);
    }

    const updateCalloutItems = (updatedNoCalloutInvoiceNotes: string, updatedCalloutNotes: string, invoiceItems: ExtraInvoiceItems[]) => {
        props.updateJobField("calloutNotes", updatedCalloutNotes);
        props.updateJobField("noCalloutInvoiceNotes", updatedNoCalloutInvoiceNotes);
        props.updateJobInvoices(invoiceItems);
    }

    const updateChargeCalloutFee = (updatedChargeCalloutFee: boolean) => {
        setChargeCalloutFee(updatedChargeCalloutFee);
    }

    const save = () => {
        props.save();
    }

    let invoiceitems = <RunsheetInvoiceItemsData showItems={false} items={[]} itemTypes={props.invoiceItemTypes} gst={props.gst} invoiceItemModalType={2} invoiceItem={props.job} chargeCalloutFee={chargeCalloutFee} errors={errors} deleteError={deleteError} updateData={updateCalloutItems} updateChargeCalloutFee={updateChargeCalloutFee} />

    const renderDetails = (
        <div>
            <div>
                <h5>
                    <span>{props.job.truck}</span>
                    <Link className={props.job.jobId === 0 ? "hidden" : "marginLeft20"} to={'/job/' + props.job.jobId + '/details'} target="_blank">
                        {props.job.jobId}
                    </Link>
                    <span className="marginLeft20">{props.job.siteAddress}</span>
                </h5>
            </div>
            <div>{props.job.driverNotes}</div>
            <div>
                <label className="input-group--inline" htmlFor="estimatedTime">
                    <span className="label-small">Est. Time:</span>
                    <span className="marginLeft10" id="estimatedTime">{props.job.estimatedTime}</span>
                </label>
                <label className="input-group--inline" htmlFor="departureTime">
                    <span className="label-small">Departure:</span>
                    <input className="marginLeft10" id="departureTime" name="departureTime" type="time" value={props.job.departureTime} onChange={(e) => handleChange(e)} />
                </label>
                <label className="input-group--inline" htmlFor="siteArrivalTime">
                    <span className="label-small">Arrival:</span>
                    <input className="marginLeft10" id="siteArrivalTime" name="siteArrivalTime" type="time" value={props.job.siteArrivalTime} onChange={(e) => handleChange(e)} />
                </label>
                <label className="input-group--inline" htmlFor="downTime">
                    <span className="label-small">Down Time:</span>
                    <input className="marginLeft10" id="downTime" name="downTime" type="time" value={props.job.downTime} onChange={(e) => handleChange(e)} />
                </label>
                <label className="input-group--inline" htmlFor="siteCompletionTime">
                    <span className="label-small">Completion:</span>
                    <input className="marginLeft10" id="siteCompletionTime" name="siteCompletionTime" type="time" value={props.job.siteCompletionTime} onChange={(e) => handleChange(e)} />
                </label>
            </div>
            <div>
                {props.job.items.map((item, index) =>
                    <div key={index}>
                        <span>{item.type}</span>
                        <span className="marginLeft20">{item.item}</span>
                        <span className="marginLeft20">{item.quantityType}</span>
                    </div>
                )}
            </div>
            <div className="runsheet-callout--width">
                {invoiceitems}
            </div>
            <button className="defaultbutton" type="button" onClick={save}>Save</button>
        </div>
    );

    const contents = renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
};

export default RunSheetDriverCallout;
